import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import InputPhoneField from '../../../components/form/InputPhoneField';
import SubmitButton from '../../../components/form/SubmitButton';
import {  useLocation, useNavigate } from 'react-router-dom';
import LoadingButton from '../../../components/form/LoadingButton';
import { apiPost } from '../../../utils/api';
import { showError, showSuccess } from '../../../utils/alert';

interface LoginFormData {
  phone: string;
}

export default function  AdminSendOtp() {
  const { t } = useTranslation();
  const { handleSubmit, register, formState: { errors } } = useForm<LoginFormData>();
  const [loading , setLoading] = useState(false);
  
 const navigate = useNavigate();

 const location = useLocation();

  
   
  const onSubmit = async (data: LoginFormData) => {
    try {
        setLoading(true);
      const response = await apiPost('otp-code/send/admin', {phone:`966${data.phone}`}) as{status:string,code:string,phone:string};
      const message =t("signup_otp");
      showSuccess(message);
        // 🔹 التقاط redirect من الـ URL
    const params = new URLSearchParams(location.search);
    const redirect = params.get("redirect");
      navigate(`/admin/verify-otp?code=${response.code}`, { state: { phone: response.phone,redirect } });
      setLoading(false);
    } catch (err: any) {
        setLoading(false);
        showError(err.message)
    }
  };

  return (
<div className="min-h-screen w-screen flex flex-col bg-light overflow-hidden">
  {/* Form Section Only */}
  <div className="flex flex-1 justify-center items-center p-8 md:p-16 min-h-screen">
    <div className="w-full max-w-md p-6 md:p-8">
      {/* Updated Title */}
      <h1 className="text-2xl text-center font-bold text-Black mb-2">
        {t('admin_login.title')}
      </h1>
      <p className="text-Black font-normal text-center mb-6">
        {t('admin_login.headline')}
      </p>

      {/* Form */}
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4" dir={"ltr"}>
        <InputPhoneField
          placeholder={t('admin_login.phonePlaceholder')}
          register={register('phone', { required: t('admin_login.phoneRequired') })}
          error={errors.phone}
        />
        {loading ? (
          <LoadingButton height={64} />
        ) : (
          <SubmitButton height={64} label={t('send_opt')} />
        )}
      </form>
    </div>
  </div>
</div>

  );
}
